import * as React from 'react';

import { DeferredServiceClientMethods, ServiceClient, createServiceClient, createDeferredServiceClient } from '../../lib/serviceClient';

export interface ServiceClientState {
    serviceClient?: ServiceClient;
}

export const ServiceClientContext = React.createContext<DeferredServiceClientMethods>(createDeferredServiceClient(createServiceClient('http://localhost:9080')));

export interface ServiceClientProviderProps {
    url: string;
}
export function ServiceClientProvider({ url, children }: React.PropsWithChildren<ServiceClientProviderProps>) {
    const serviceClient = createDeferredServiceClient(createServiceClient(url));

    return (
        <ServiceClientContext.Provider value={serviceClient}>
            {children}
        </ServiceClientContext.Provider>
    )
}
export function useServiceClient() {
    return React.useContext(ServiceClientContext);
}